import React from 'react';
import PropTypes from 'prop-types';
import ChosenSelect from './ChosenSelect';

const SubsystemFilter = ({ options, value, onChange }) => (
  <div className="subsystemSelection">
    <div className="chartControlTitle" data-testid="analysis-filters-panel-subsystems-label">Subsystems</div>
    <div className="input-group subsystemSelectorGroup">
      <i className="fas fa-search input-group-addon" />
      <ChosenSelect
        options={options}
        value={(value || []).map(option => String(option.value ?? option.id))}
        multiple
        className="subsystemSelect"
        onChange={selectedValues => onChange(options.filter(option => selectedValues.includes(String(option.value ?? option.id))))}
        renderOption={option => option.name || option.title || option.value}
        testId="analysis-filters-panel-subsystems-select"
      />
      <span className="input-group-addon" title="Clear selection">
        <button type="button" className="analysis-filter-clear" aria-label="Clear subsystems selection"
          onClick={() => onChange([])} data-testid="analysis-filters-panel-subsystems-clear">
          <i className="fas fa-times" aria-hidden="true" />
        </button>
      </span>
    </div>
  </div>
);

SubsystemFilter.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SubsystemFilter;